import { observer } from 'mobx-react-lite'
import { UrlShortenerListHeader } from 'pages/settings/pages/urlShortener/ui/UrlShortenerList/UrlShortenerListHeader'
import { UrlShortenerListTable } from 'pages/settings/pages/urlShortener/ui/UrlShortenerListTable/UrlShortenerListTable'
import { UrlShortenerInfo } from 'pages/settings/pages/urlShortener/ui/UrlShortenerInfo/UrlShortenerInfo'
import styles from './styles.module.scss'

export const UrlShortenerList = observer(() => {
  return (
    <section className={styles.page}>
      <UrlShortenerListHeader />
      <UrlShortenerInfo />
      <div className={styles.wrap}>
        <UrlShortenerListTable />
      </div>
    </section>
  )
})
